import React, { Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from 'components/shared/RouteWithSubRoutes';

import LoadingSpinner from 'components/shared/LoadingSpinner';
import CustomEmpty from 'components/shared/CustomEmpty';

import { PUBLIC_ZONE_FALLBACK_GLOBS } from 'constants/publicPaths';

import routes from './routes';

const PublicRoutes = () => {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Switch>
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={`${i}_${route.path}`} {...route} />
        ))}
        {PUBLIC_ZONE_FALLBACK_GLOBS.map((path) => (
          <Route key={path} path={path}>
            <CustomEmpty messages={['pagina no encontrada']} />
          </Route>
        ))}
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    </Suspense>
  );
};

export default PublicRoutes;
